<template>
  <div class="local-container">
    <svg ref="svg" class="chart"></svg>
    <div v-if="loading" class="loading-container">
      <v-progress-circular class="loading-sign" :size="50" color="#808080" indeterminate></v-progress-circular>
    </div>
    <div v-if="!loading" class="legend">
      <div class="header">
        Groups
        <v-spacer></v-spacer>

        <a v-if="this.selectAll" @click="alterSelection()">Deselect all</a>
        <a v-else @click="alterSelection()">Select all</a>
      </div>
      <v-checkbox v-model="$store.state.graphs.waitingTimeCheckBoxes.B" class="px-3" label="Blue" :color="colorMapper.B" @change="updateGraph()" hide-details></v-checkbox>
      <v-checkbox v-model="$store.state.graphs.waitingTimeCheckBoxes.O" class="px-3" label="Orange" :color="colorMapper.O" @change="updateGraph()" hide-details></v-checkbox>
      <v-checkbox v-model="$store.state.graphs.waitingTimeCheckBoxes.I" class="px-3" label="Indigo" :color="colorMapper.I" @change="updateGraph()" hide-details></v-checkbox>
      <v-checkbox v-model="$store.state.graphs.waitingTimeCheckBoxes.M" class="px-3" label="Maroon" :color="colorMapper.M" @change="updateGraph()" hide-details></v-checkbox>
      <v-checkbox v-model="$store.state.graphs.waitingTimeCheckBoxes.A" class="px-3" label="Aqua" :color="colorMapper.A" @change="updateGraph()" hide-details></v-checkbox>
      <v-checkbox v-model="$store.state.graphs.waitingTimeCheckBoxes.P" class="px-3 pb-5" label="Pink" :color="colorMapper.P" @change="updateGraph()" hide-details></v-checkbox>
              

      <div class="header">
        Options
      </div>

      <v-subheader  class="custom-subheader" hide-details>Rolling average available work: {{ this.waitingAverage }} hours </v-subheader>
        <div class="thresholdslidecontainer">
          <input id="indexslider3" type="range" min="1" max="100" @input="(v) => updateWaitingAverage(v)" :value="this.waitingAverage" class="indexslider" />
        </div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  name: "LineChart",
  components: {},
  data: () => ({
    transform: null,
    waitingAverage: 1,
    selection: null,
    selectAll: true,
    colorMapper: { B: "#00A1FF", O: "#FEAE00", I: "#004D80", M: "#A33D32", A: "#16E7CF", P: "#FF42A1" },
    focusPaths: {},
    contextPaths: {},
    updateDomain: null,
    loading: true,
    resizeFunction: null,
    maxZoom: 10,
  }),
  props: {
    id: { type: String, required: true },
  },
  methods: {
    updateWaitingAverage(v){
      this.waitingAverage = v.srcElement.value;
      this.updatePaths();
    },
    transformMovingAverage(dataSequence){
      var windowSize = this.waitingAverage;
      var movingAverage = [];

      for (var i = 0; i < dataSequence.length; i++) {
        var sum = 0;
        var count = 0;

        for (var j = Math.max(0, i - windowSize + 1); j <= i; j++) {
          sum += dataSequence[j].waitingTime;
          count++;
        }

        movingAverage.push({
          day: dataSequence[i].day,
          group: dataSequence[i].group,
          waitingTime: sum / count
        });
      }

      return movingAverage;
    },
    updateGraph() {
      if (this.updateDomain != null) {
        this.updateDomain(true);
      }
    },
    alterSelection() {
      for (const [key, val] of Object.entries(this.$store.state.graphs.waitingTimeCheckBoxes)) {
        this.$store.state.graphs.waitingTimeCheckBoxes[key] = !this.selectAll;
      }

      this.selectAll = !this.selectAll;

      this.updateGraph();
    },

    getOpacity(groupCode) {
      var returnVal = 0;
      if (this.$store.state.graphs.waitingTimeCheckBoxes[groupCode]) {
        returnVal = 1;
      }
      return returnVal;
    },
    parseData(metrics) {
      var parsedData = [];
      if (metrics.length <= 1) {
        return parsedData;
      }
      this.$store.state.ResourceGroups.forEach((currGroup) => {
        metrics.forEach((currMetric) => {
          if (currMetric.currHour == 0) {
            parsedData.push({ day: 0, group: currGroup.id, waitingTime: metrics[1].waitingTime[currGroup.id]});
            return;
          }
          parsedData.push({ day: currMetric.currHour / 8, group: currGroup.id, waitingTime: currMetric.waitingTime[currGroup.id] });
        });
      });

      return parsedData;
    },
    showgraph() {
      return this.$store.state.simulator != null && this.$store.state.simulator.params.showGraphs;
    },
  },
  async mounted() {
    // this.$store.state.simulator.automateUntilEnd("EpicFlow", []);


    
    if (!this.showgraph()) {
      this.loading = false;
      return;
    }

    var duration = 300;
    var first = true;
    var self = this;



    var margin = { top: 40, right: 230, bottom: 75, left: 75, between: 50 };
    var svg = d3.select(this.$refs.svg);
    var width;
    var height;
    var height2;

    var x = d3.scaleLinear();
    var x2 = d3.scaleLinear();
    var y = d3.scaleLinear();
    var y2 = d3.scaleLinear();

    var xAxis = d3.axisBottom(x);

    var xAxis2 = d3.axisBottom(x2);
    var yAxis = d3.axisLeft(y);

    var brush = d3.brushX().on("brush end", brushed);

    var line1 = d3
      .line()
      .x(function (d) {
        return x(d.day);
      })
      .y(function (d) {
        return y(d.waitingTime);
      });

    var line2 = d3
      .line()
      .x(function (d) {
        return x2(d.day);
      })
      .y(function (d) {
        return y2(d.waitingTime);
      });

    self.data = this.parseData(this.$store.state.simulator.performanceTracker.metrics);

    var clipRect = svg
      .append("defs")
      .append("clipPath")
      .attr("id", "clip" + this.id)
      .append("rect");
    var focus = svg.append("g").attr("class", "focus");
    var zoomFrame = svg.append("rect").attr("class", "zoom");

    var focusX = focus.append("g").attr("class", "axis axis--x");
    var focusY = focus.append("g").attr("class", "axis axis--y");

    var context = svg.append("g").attr("class", "context");
    var contextX = context.append("g").attr("class", "axis axis--x");

    var brushG;
    var zoom;

    var sumstat = Array.from(
      d3.group(self.data, (d) => d.group),
      ([key, value]) => ({ key, value })
    );

    x.domain([0, this.$store.state.simulator.hoursPassed / 8]);

    y.domain([
      Math.min(
        0,
        d3.min(self.data, function (d) {
          return d.waitingTime;
        })
      ),
      Math.max(
        1,
        parseFloat(
          d3.max(self.data, function (d) {
            return d.waitingTime;
          })
        ) + 0.1
      ),
    ]);

    if (self.data.length == 0) {
      y.domain([0, 1]);
      x.domain([0, 1]);
    }
    var line1 = d3
      .line()
      .x(function (d) {
        return x(d.day);
      })
      .y(function (d) {
        return y(d.waitingTime);
      });

    var yAxisLine = focus.append("line").attr("x1", x(x.domain()[0])).attr("y1", y(0)).attr("x2", x(x.domain()[1])).attr("y2", y(0)).attr("stroke-width", 4).attr("stroke", "#4358C0").attr("clip-path", `url(#clip${this.id})`);

    var yAxisLabel = focus.append("text").attr("class", "y label").attr("text-anchor", "middle").attr("y", -60).attr("dy", ".75em").attr("transform", "rotate(-90)").text("Available work of the tasks for a resource (hours)").attr("style", "fill: gray; font-size: 1.3em;");
    var xAxisLabel = focus.append("text").attr("class", "x label").attr("text-anchor", "middle").attr("dy", ".75em").text("Days").attr("style", "fill: gray; font-size: 1.3em;");
    var xAxisLabel2 = focus.append("text").attr("class", "x label").attr("text-anchor", "middle").attr("dy", ".75em").text("Days").attr("style", "fill: gray; font-size: 1.3em;");

    sumstat.forEach((lineData) => {
      var focusLine = focus
        .append("path")
        .datum(lineData.value)
        .attr("class", "line") // I add the class line to be able to modify this line later on.
        .attr("fill", "none")
        .attr("stroke", this.colorMapper[lineData.key])
        .attr("stroke-width", 2)
        .attr(
          "d",
          d3
            .line()
            .x(function (d) {
              return x(d.day);
            })
            .y(function (d) {
              return y(d.waitingTime);
            })
        )
        .attr("clip-path", `url(#clip${this.id})`);

      if (first) {
        focusLine.transition().duration(duration).attr("opacity", 1);
      }

      var contextPath = context
        .append("path")
        .datum(lineData.value)
        .attr("class", "line") // I add the class line to be able to modify this line later on.
        .attr("fill", "none")
        .attr("stroke", this.colorMapper[lineData.key])
        .attr("stroke-width", 1)
        .attr("clip-path", `url(#clip${this.id})`)

        .attr(
          "d",
          d3
            .line()
            .x(function (d) {
              return x(d.day);
            })
            .y(function (d) {
              return y(d.waitingTime);
            })
        );
      this.focusPaths[lineData.key] = focusLine;
      this.contextPaths[lineData.key] = contextPath;
    });

    x2.domain(x.domain());
    y2.domain(y.domain());

    if (!brushG) brushG = context.append("g").attr("class", "brush");

    resize();
    first = false;


    function updatePaths(){

      //Update the line to use the clipped data
      focus.selectAll(".line")

        .transition()
        .duration(1000)

        .attr("d", function(d) {
          var lineData = self.transformMovingAverage(d);

          return d3.line()

            .x(function (d) {
              return x(d.day);
            })
            .y(function (d) {
              return y(d.waitingTime);
            })(lineData);
        });
    }
      
      this.updatePaths = updatePaths;

          function zoomed(event) {
            if (event.sourceEvent == null) return; // ignore zoom-by-brush
            var t = event.transform;

            var domain = t.rescaleX(x2).domain();

            x.domain(domain);
            updateDomain(false);
            //focus.selectAll(".line").attr("d", line1);
            focus.select(".axis--x").call(xAxis);
            context.select(".brush").call(brush.move, x.range().map(t.invertX, t));
          }

          // function updateDomain(addDuration) {
          //   var filteredData = self.data.filter((d) => d.day > x.domain()[0] && d.day < x.domain()[1] && self.$store.state.graphs.waitingTimeCheckBoxes[d.group]);
          //   console.log(filteredData);
          //   if (filteredData.length == 0) {
          //     y.domain([-1, 1]);
          //   } else {
          //     y.domain([
          //       Math.min(
          //         0,
          //         d3.min(filteredData, function (d) {
          //             return d.waitingTime;
          //         })
          //       ),
          //       Math.max(
          //         40,
          //         d3.max(filteredData, function (d) {
          //             return d.waitingTime;
          //         })
          //       ),
          //     ]);
          //   }

          //   focus.select(".axis--y").transition().duration(addDuration ? duration : 0).call(yAxis);
          //   focus.select(".y.label").transition().duration(addDuration ? duration : 0).attr("y", -60);
          //   focus.select(".x.label").transition().duration(addDuration ? duration : 0).attr("y", height - 10);
          //   focus.select(".x.label2").transition().duration(addDuration ? duration : 0).attr("y", height - 10);
          //   focus.select(".yAxisLine").transition().duration(addDuration ? duration : 0).attr("y1", y(0)).attr("y2", y(0));
          //   focus.selectAll(".line").transition().duration(addDuration ? duration : 0).attr("d", function (d) {
          //     return line(d.value);
          //   });
          // }

          function updatePaths(){
            //Update the lines so that they are clipped to max 40
            focus.selectAll(".line").attr("d", function(d) {
              var lineData = d.value.filter(function(d) {
                return d.waitingTime <= 40;
              });
              return line(lineData);
            });
          }
    this.updatePaths = updatePaths;

    function zoomed(event) {
      if (event.sourceEvent == null) return; // ignore zoom-by-brush
      var t = event.transform;

      var domain = t.rescaleX(x2).domain();

      x.domain(domain);
      updateDomain(false);
      //focus.selectAll(".line").attr("d", line1);
      focus.select(".axis--x").call(xAxis);
      context.select(".brush").call(brush.move, x.range().map(t.invertX, t));
    }

    function updateDomain(addDuration) {
      var filteredData = self.data.filter((d) => d.day > x.domain()[0] && d.day < x.domain()[1] && self.$store.state.graphs.waitingTimeCheckBoxes[d.group]);
      
      if (filteredData.length == 0) {
        y.domain([-1, 1]);
      } else {
        y.domain([
          Math.min(
            0,
            d3.min(filteredData, function (d) {
              return d.waitingTime;
            })
          ),
          Math.max(
            1,
            parseFloat(
              d3.max(filteredData, function (d) {
                return d.waitingTime;
              })
            ) + 0.1
          ),
        ]);
      }

      


      focusY.transition().duration(300).call(yAxis);
      if (addDuration) {
        focus
          .selectAll(".line")
          .transition()
          .duration(300)
          .attr("d", function(d) {
          var lineData = self.transformMovingAverage(d);

          return d3.line()

            .x(function (d) {
              return x(d.day);
            })
            .y(function (d) {
              return y(d.waitingTime);
            })(lineData);
        })
          .attr("opacity", function (d) {
            return self.getOpacity(d[0].group);
          }); //d => 1 ? self.$store.state.graphs.waitingTimeCheckBoxes[d[0].group] : 0);
        yAxisLine.transition().duration(300).attr("x1", x(-10)).attr("y1", y(0)).attr("x2", x(1000)).attr("y2", y(0));
      } else {
        focus
          .selectAll(".line")
          .attr("d", function(d) {
          var lineData = self.transformMovingAverage(d);

          return d3.line()

            .x(function (d) {
              return x(d.day);
            })
            .y(function (d) {
              return y(d.waitingTime);
            })(lineData);
        })
          .attr("opacity", function (d) {
            return self.getOpacity(d[0].group);
          });
        yAxisLine.attr("x1", x(-10)).attr("y1", y(0)).attr("x2", x(1000)).attr("y2", y(0));
      }
      
    }

    this.updateDomain = updateDomain;

    function brushed(event) {
      if (event.sourceEvent == null) {
        return; // ignore brush-by-zoom
      }
      var s = event.selection || x2.range();

      var relativeSize = (100 * (s[1] - s[0])) / width;

      if (relativeSize < self.maxZoom) {
        var diff = (width * (self.maxZoom - relativeSize)) / 100;

        var diffRight = diff / 2;
        var diffLeft = diff / 2;
        if (s[0] < diffLeft) {
          diffRight += diffLeft - s[0];
          diffLeft = s[0];
        }

        if (s[1] + diffRight > width) {
          var max = width - s[1];
          diffLeft += diffRight - max;
          diffRight = max;
        }
        s[0] -= diffLeft;
        s[1] += diffRight;

        context.select(".brush").call(brush.move, s);
      }
      var domain = s.map(x2.invert, x2);

      x.domain(domain);
      updateDomain(false);

      //focus.selectAll(".line").attr("d", line1);
      focus.select(".axis--x").call(xAxis);
      svg.select(".zoom").call(zoom.transform, d3.zoomIdentity.scale(width / (s[1] - s[0])).translate(-s[0], 0));
    }

    function resize() {
      if (self.$router.currentRoute.path != "/graphs") {
        return;
      }

      var widthBefore = width;
      1;

      var container = svg.node().parentNode;

      var svgWidth = container.clientWidth;
      var svgHeight = container.clientHeight;
      if (svgWidth == 0) {
        return;
      }

      svg.attr("width", svgWidth);
      svg.attr("height", svgHeight);

      width = svgWidth - margin.left - margin.right;
      var totalHeight = svgHeight - margin.top - margin.bottom - margin.between;
      height = totalHeight * 0.8;
      height2 = totalHeight * 0.2;

      if (width < 0 || height < 0) {
        return;
      }
      zoomFrame
        .attr("width", width)
        .attr("height", height)
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
      x.range([0, width]);
      x2.range([0, width]);
      y.range([height, 0]);
      y2.range([height2, 0]);

      brush.extent([
        [0, 0],
        [width, height2],
      ]);

      xAxis.ticks(10).tickSize(-height, 0, 0);
      yAxis.ticks(5).tickSize(-width, 0, 0);
      zoom = d3
        .zoom()
        .scaleExtent([1, self.maxZoom])
        .translateExtent([
          [0, 0],
          [width, height],
        ])
        .extent([
          [0, 0],
          [width, height],
        ])
        .on("zoom", zoomed);
      //area.y0(height);
      //area2.y0(height2);

      clipRect.attr("width", width).attr("height", height);

      focus.attr("transform", "translate(" + margin.left + "," + margin.top + ")");
      focusX.attr("transform", "translate(0," + height + ")").call(xAxis);

      yAxisLabel.attr("x", -275);
      xAxisLabel.attr("x", svgWidth / 2 - 148).attr("y", 570);
      xAxisLabel2.attr("x", svgWidth / 2 - 148).attr("y", 770);

      focusY.call(yAxis);

      var top2 = margin.top + height + margin.between;
      context.attr("transform", "translate(" + margin.left + "," + top2 + ")");
      contextX.attr("transform", "translate(0," + height2 + ")").call(xAxis2);

      focus.selectAll("path.line").attr("d", function(d) {
          var lineData = self.transformMovingAverage(d);

          return d3.line()

            .x(function (d) {
              return x(d.day);
            })
            .y(function (d) {
              return y(d.waitingTime);
            })(lineData);
        });
      context.selectAll("path.line").attr("d", line2);
      zoomFrame.call(zoom);

      var brushSelection = null;
      var brushNode = context.select("g.brush").node();
      if (brushNode) brushSelection = d3.brushSelection(brushNode);

      if (brushSelection) {
        brushSelection = brushSelection.map(function (x) {
          return x * (width / widthBefore);
        });
      } else brushSelection = x.range();

      context.select("g.brush").call(brush).call(brush.move, brushSelection);

      if (first) {
        svg.select("g.focus").transition().duration(duration).attr("opacity", 1);
        svg.select("g.context").transition().duration(duration).attr("opacity", 1);
      }

    }

    window.addEventListener("resize", resize);

    if (first) {
    }
    this.loading = false;
    this.resizeFunction = resize;
    this.$emit("loaded", this);
    // updateDomain(true);
    setInterval(resize, 100);
    setTimeout(function() {updateDomain(true)}, 100);
    first = false;
    yAxisLine.attr("x1", x(-10)).attr("y1", y(0)).attr("x2", x(1000)).attr("y2", y(0));

    this.resizeFunction();
  },
};
</script>

<style>
.domain {
  stroke: lightgrey;
}
.tick line {
  stroke: lightgrey;
  stroke-opacity: 0.7;
  shape-rendering: crispEdges;
}

g.tick line {
  stroke: lightgrey;
  stroke-opacity: 0.7;
  shape-rendering: crispEdges;
}
.axis line {
  stroke: lightgrey;
  stroke-opacity: 0.7;
  shape-rendering: crispEdges;
}
rect.selection {
  fill: steelblue;
  stroke: steelblue;
  stroke-width: 1px;
  opacity: 1;
}
rect.zoom {
  cursor: move;
  fill: none;
  pointer-events: all;
}
</style>

<style scoped>
.local-container {
  width: 100%;
  height: 100%;
}
.graph-name {
  position: absolute;
  width: calc(100% - 220px);
  justify-content: center;
  display: flex;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 16px;
  top: 15px;
  color: #4a4a4a;
}
.legend {
  width: 220px;
  height: 100%;
  max-width: 220px;
  background-color: #fdfdfd;
  border-left: solid 1px #dcdcdc;
  font-size: 25px;
  position: absolute;
  right: 0;
  top: 0;
}
.futureloadcontainer {
  display: flex;
  width: 100%;
}
.loading-container {
  position: absolute;
  height: 560px;
  width: calc(100% - 220px);
  display: flex;
  justify-content: center;
}
.loading-sign {
  height: 560px;
  top: 220px;
}
.header {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #4a4a4a;
  display: flex;
  padding: 15px;
  padding-bottom: 0;
}
.selection {
  color: red;
  background-color: red;
}

.noGraphs {
  width: 100%;
  height: 100%;
  padding: 50px;
  display: flex;
  font-size: 2em;
  font-family: Helvetica, sans-serif;
  font-weight: bold;
}

.nographText {
  width: 100%;
  height: 100%;
  text-align: center;
}
.totalChart {
  width: 100%;
}
.charts {
  overflow: auto;
  height: 100%;
}

.checkBoxes {
  width: 100%;
  display: flex;
  justify-content: center;
}

.totalChartContainer {
  width: 100%;
  display: flex;
}
.chart {
  width: 100%;
}
.zoom {
  cursor: move;
  pointer-events: all;
  color: green;
}

/* The slider itself */
.indexslider {
  -webkit-appearance: none; /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  height: 25px; /* Specified height */
  background: #d3d3d3; /* Grey background */
  outline: none; /* Remove outline */
  opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
  -webkit-transition: 0.2s; /* 0.2 seconds transition on hover */
  transition: opacity 0.2s;
  display: flex;
}

/* Mouse-over effects */
.indexslider:hover {
  opacity: 1; /* Fully shown on mouse-over */
}

.custom-subheader {
  font-size: 16px; /* Adjust the font size as needed */

  padding: 0px;
  padding-left: 17px;
  padding-top: 13px;
  margin: 0px;
  margin-top: 14px;
  margin-bottom: 5px;
  height: 20px;
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.indexslider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #3f51b5; /* Green background */
  cursor: pointer; /* Cursor on hover */
}

.options {
}

.indexslider::-moz-range-thumb {
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #3f51b5; /* Green background */
  cursor: pointer; /* Cursor on hover */
}

.indexslider {
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  float: "right";
}

.indexslider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #3f51b5; /* Green background */
  cursor: pointer;
}

.indexslider::-moz-range-thumb {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #3f51b5; /* Green background */
  cursor: pointer;
}

.thresholdslidecontainer {
  padding: 10px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top:20px;
}
</style>
